export default class UpdateMarkerTypeModel {
    organizationId = null;
    id = null;
    label = null;
    description = null;
    isActive = false;
    color = null;
    shape = null;
    eTag = null;

    constructor(id, organizationId, label, description, isActive, eTag, color = null, shape = null){
        this.id = id;
        this.organizationId = organizationId;
        this.label = label;
        this.description = description;
        this.isActive = isActive;
        this.color = color;
        this.shape = shape;
        this.eTag = eTag;
    }
}
